'use strict';
define([
    '../../../lib/domQ'
], function (domQ) {
    return {
        init: function () {
            this.hamburgerMenu = document.querySelector('.navigation-res-nav-header__item--menu .navigation-hamburger-trigger');
            this.searchIcon = document.querySelector('.navigation-btn__icon--search-container');
            this.bodyEl = document.querySelector('body');
            this.tempAcc = document.querySelector('.navigation-stick-temp-hold');
            this.logo = document.querySelector('.navigation-mns-logo');
            this.signInIcon = document.querySelector('.navigation-res-nav-header__login-link');
            this.accountIcon = document.querySelector('.navigation-res-nav-header__icon--my-account');
            this.bagIcon = document.querySelector('.navigation-res-nav-header__item--bag .navigation-header__link');
            this.listCheveronIcons = document.querySelectorAll('.navigation-l1-chervonicon');
            this.navItems = document.querySelectorAll('.nav-primary__menu-link');
            this.minibagChevron = document.querySelector('.navigation-chevronicon__minibag');
            this.acctChevron = document.querySelector('.navigation-accessibility__chevron-account');
            this.countrylink = document.querySelector('.navigation-res-nav-header__icon--country');
            this.helpLink = document.querySelector('.navigation-help a');
            this.locationLink = document.querySelector('.navigation-res-nav-header__icon--location');
            this.skipContent = document.querySelector('.navigation-skip-content button');
            this.menulogo = document.querySelector('.navigation-burger__fixedtopmenu .navigation-mns-logo');
            this.closeSearchButton = document.querySelector('.navigation-search-bar--clear');
            this.insideLogo = document.querySelector('.navigation-burger__fixedtopmenu a');
            this.closeMenuButton = document.querySelector('.navigation-burger__fixedtopmenu .navigation-burger-close');
            this.tempStickySearch = document.querySelector('.navigation-temp-search-acc');
            this.countryOverlay = document.querySelector('.navigation-mobile-country-header');
            this.headerEl = document.getElementById('common-hdr-main');
            this.tempL2Holder = document.querySelector('.navigation-temp-accessibility');
            this.countryItems = document.querySelectorAll('.navigation-nav-country-selector select, .navigation-nav-country-selector a');
            this.backClick = document.querySelector('.navigation-submenu__back-bar-link');
            this.countryFocus = document.querySelector('.navigation-country-mobile--link');
            this.submenuContainer = document.querySelector('.navigation-primary__submenu-container');
            this.navContainer = document.querySelector('.navigation-primary__section');
            this.signInCheveron = document.querySelector('.navigation-accessibility__chevron');
            this.toggleCountryOverlay = this.toggleCountryOverlay.bind(this);
            this.searchOverlay = this.searchOverlay.bind(this);
            this.focusSearchOverlay = this.focusSearchOverlay.bind(this);
            this.hamburgerMenuOpen = this.hamburgerMenuOpen.bind(this);
            this.hamburgerMenuClose = this.hamburgerMenuClose.bind(this);
            this.skiptoPage = this.skiptoPage.bind(this);
            this.openl23 = this.openl23.bind(this);
            this.closel23 = this.closel23.bind(this);
            this.jumptoTopL23 = this.jumptoTopL23.bind(this);
            this.backClickKeyup = this.backClickKeyup.bind(this);
            this.escapeToClose = this.escapeToClose.bind(this);
            this.bagIconFocus = this.bagIconFocus.bind(this);
            this.bindAnchor = this.bindAnchor.bind(this);
        },
        bindAccessibility: function (activeElement) {
            this.init();
            this.activeElement = activeElement;
            if(activeElement === this.bodyEl || this.headerEl.contains(activeElement)) {
                this.tempAcc.focus();
            }
            this.searchIcon.addEventListener('click', this.searchOverlay);
            this.backClick.addEventListener('keyup', this.backClickKeyup);
            this.closeSearchButton.addEventListener('keyup', this.focusSearchOverlay);
            this.tempStickySearch.addEventListener('keyup', this.focusSearchOverlay);
            this.hamburgerMenu.addEventListener('keyup', this.hamburgerMenuOpen);
            this.closeMenuButton.addEventListener('keyup', this.hamburgerMenuClose);
            this.minibagChevron.addEventListener('keyup', this.skiptoPage);
            this.tempL2Holder.addEventListener('keyup', this.jumptoTopL23);
            this.countryFocus.addEventListener('keyup', this.closel23);
            this.headerEl.addEventListener('keyup', this.escapeToClose);
            this.bagIcon.addEventListener('keyup', this.bagIconFocus);
        },
        unbindAccessibility: function () {
            this.init();
            this.backClick.removeAttribute('tabIndex');
            this.tempL2Holder.removeAttribute('style');
            this.minibagChevron.removeAttribute('style');
            this.searchIcon.removeEventListener('click', this.searchOverlay);
            this.closeSearchButton.removeEventListener('keyup', this.focusSearchOverlay);
            this.tempStickySearch.removeEventListener('keyup', this.focusSearchOverlay);
            this.hamburgerMenu.removeEventListener('keyup', this.hamburgerMenuOpen);
            this.closeMenuButton.removeEventListener('keyup', this.hamburgerMenuClose);
            this.minibagChevron.removeEventListener('keyup', this.skiptoPage);
            this.tempL2Holder.removeEventListener('keyup', this.jumptoTopL23);
            this.backClick.removeEventListener('keyup', this.backClickKeyup);
            this.countryFocus.removeEventListener('keyup', this.closel23);
            this.headerEl.removeEventListener('keyup', this.escapeToClose);
            this.bagIcon.removeEventListener('keyup', this.bagIconFocus);
        },
        bagIconFocus: function () {
            this.minibagChevron.style.display = 'block';
        },
        toggleCountryOverlay: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 13 || keyPressed === 'Enter') {
                this.countryOverlay.click();
            }
        },
        searchOverlay: function (event) {
            event.preventDefault();
            document.querySelector('.navigation-btn__icon--search').click();
        },
        focusSearchOverlay: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (event.target === this.closeSearchButton && (keyPressed === 13 || keyPressed === 'Enter')) {
                this.searchIcon.focus();
            } else if (event.target !== this.closeSearchButton) {
                this.closeSearchButton.click();
                this.searchIcon.focus();
            }
        },
        hamburgerMenuOpen: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 13 || keyPressed === 'Enter') {
                if (domQ(this.submenuContainer).hasClass('navigation-is-active')) {
                    document.querySelector('.navigation-submenu__back-bar-label a').focus();
                } else {
                    this.insideLogo.focus();
                }
                this.tempAcc.addEventListener('keyup', this.hamburgerMenuClose);
                this.countryOverlay.addEventListener('keyup', this.toggleCountryOverlay);
                for (var navI = 0; navI < this.navItems.length; navI++) {
                    this.navItems[navI].addEventListener('keyup', this.openl23);
                }
            }
        },
        hamburgerMenuClose: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (event.target === this.tempAcc) {
                this.closeMenuButton.click();
                this.hamburgerMenu.focus();
            }
            if (((keyPressed === 13 || keyPressed === 'Enter') && event.target === this.closeMenuButton) || (event.target === this.tempAcc)) {
                this.insideLogo.removeAttribute('tabIndex');
                this.closeMenuButton.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
                for (var navI = 0; navI < this.navItems.length; navI++) {
                    this.navItems[navI].removeEventListener('keyup', this.openl23);
                }
                this.hamburgerMenu.focus();
            }
        },

        skiptoPage: function () {
            var pageContent = this.headerEl.nextElementSibling;
            if (pageContent && domQ(this.headerEl).hasClass('navigation-sticky')) {
                var initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                while (pageContent && pageContent !== null && !initialContentLink) {
                    pageContent = pageContent.nextElementSibling;
                    if (pageContent) {
                        initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                    }
                }
                if (initialContentLink) {
                    window.navSkiptoPage = true;
                    var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
                    if (userAgent.indexOf('MSIE') !== -1 || window.navigator.appVersion.indexOf('Trident/') > 0) {
                        var evt = document.createEvent('UIEvents');
                        evt.initUIEvent('scroll', true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        window.dispatchEvent(new Event('scroll')); // eslint-disable-line no-undef
                    }
                    initialContentLink.focus();
                }
            }
        },

        openl23: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 13 || keyPressed === 'Enter') {
                document.querySelector('.navigation-submenu__back-bar-label a').focus();
                window.stickyActiveL1 = event.target;
            }
        },
        closel23: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (event.target === this.countryFocus && domQ(this.submenuContainer).hasClass('navigation-is-active')) {
                this.backClick.click();
                window.stickyActiveL1.focus();
            }
            else if (event.target === this.countryFocus && (keyPressed === 13 || keyPressed === 'Enter') && this.countryFocus.href === 'javascript:;') {
                this.insideLogo.removeAttribute('tabIndex');
                this.closeMenuButton.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
                for (var navI = 0; navI < this.navItems.length; navI++) {
                    this.navItems[navI].removeEventListener('keyup', this.openl23);
                }
                this.hamburgerMenu.focus();
            }
        },
        jumptoTopL23: function () {
            this.backClick.focus();
        },
        backClickKeyup: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 13 || keyPressed === 'Enter') {
                this.backClick.click();
                window.stickyActiveL1.focus();
            }
        },
        escapeToClose: function (event) {
            var keyPressed = event.key || event.keyCode;
            if ((keyPressed === 27 || keyPressed === 'Escape') && domQ(this.submenuContainer).hasClass('navigation-is-active')) {
                this.backClick.click();
                window.stickyActiveL1.focus();
            }
            else if ((keyPressed === 27 || keyPressed === 'Escape') && domQ(this.navContainer).hasClass('navigation-is-active')) {
                this.insideLogo.removeAttribute('tabIndex');
                this.closeMenuButton.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('tabIndex');
                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
                for (var navI = 0; navI < this.navItems.length; navI++) {
                    this.navItems[navI].removeEventListener('keyup', this.openl23);
                }
                this.closeMenuButton.click();
                this.hamburgerMenu.focus();
            }
        },
        bindAnchor: function() {
            this.tempAcc.addEventListener('keyup', this.hamburgerMenuClose);
            this.countryOverlay.addEventListener('keyup', this.toggleCountryOverlay);
            for (var navI = 0; navI < this.navItems.length; navI++) {
                this.navItems[navI].addEventListener('keyup', this.openl23);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/stickyHeader.js